var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFallbackProduct = function SvgFallbackProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296 369"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8F7F7",
    d: "M0 0h296v369H0z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    transform: "translate(113.102 161.628)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEAEAF",
    d: "M15.538 29.886 31.23 45.54H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.325,
    cy: 7.827,
    fill: "#AEAEAF",
    rx: 7.808,
    ry: 7.827
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E1D1D",
    d: "m45.545 21.821 24.015 23.72H21.767z"
  })))));
};
export default SvgFallbackProduct;